/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ModelsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ModelsAPIApi - axios parameter creator
 * @export
 */
export const ModelsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets models used by all runbook types.
         * @summary Get models used by all runbook types.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsAPIGetModels: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('modelsAPIGetModels', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/models`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the mapping of LLM providers to models used per runbook type
         * @summary Get the mapping between provider and models used per runbook type.
         * @param {string} organizationId The ID of the organization.
         * @param {ModelsAPIGetModelsByRunbookTypeTypeEnum} type The runbook type to get LLMs for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsAPIGetModelsByRunbookType: async (organizationId: string, type: ModelsAPIGetModelsByRunbookTypeTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('modelsAPIGetModelsByRunbookType', 'organizationId', organizationId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('modelsAPIGetModelsByRunbookType', 'type', type)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-types/{type}/models`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelsAPIApi - functional programming interface
 * @export
 */
export const ModelsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets models used by all runbook types.
         * @summary Get models used by all runbook types.
         * @param {string} organizationId The ID of the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelsAPIGetModels(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelsAPIGetModels(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelsAPIApi.modelsAPIGetModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the mapping of LLM providers to models used per runbook type
         * @summary Get the mapping between provider and models used per runbook type.
         * @param {string} organizationId The ID of the organization.
         * @param {ModelsAPIGetModelsByRunbookTypeTypeEnum} type The runbook type to get LLMs for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelsAPIGetModelsByRunbookType(organizationId: string, type: ModelsAPIGetModelsByRunbookTypeTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelsAPIGetModelsByRunbookType(organizationId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelsAPIApi.modelsAPIGetModelsByRunbookType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModelsAPIApi - factory interface
 * @export
 */
export const ModelsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelsAPIApiFp(configuration)
    return {
        /**
         * Gets models used by all runbook types.
         * @summary Get models used by all runbook types.
         * @param {ModelsAPIApiModelsAPIGetModelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsAPIGetModels(requestParameters: ModelsAPIApiModelsAPIGetModelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ModelsResponse> {
            return localVarFp.modelsAPIGetModels(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the mapping of LLM providers to models used per runbook type
         * @summary Get the mapping between provider and models used per runbook type.
         * @param {ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelsAPIGetModelsByRunbookType(requestParameters: ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ModelsResponse> {
            return localVarFp.modelsAPIGetModelsByRunbookType(requestParameters.organizationId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for modelsAPIGetModels operation in ModelsAPIApi.
 * @export
 * @interface ModelsAPIApiModelsAPIGetModelsRequest
 */
export interface ModelsAPIApiModelsAPIGetModelsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ModelsAPIApiModelsAPIGetModels
     */
    readonly organizationId: string
}

/**
 * Request parameters for modelsAPIGetModelsByRunbookType operation in ModelsAPIApi.
 * @export
 * @interface ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest
 */
export interface ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof ModelsAPIApiModelsAPIGetModelsByRunbookType
     */
    readonly organizationId: string

    /**
     * The runbook type to get LLMs for.
     * @type {'RUNBOOK_TYPE_UNSPECIFIED' | 'WOOP_RECOMMENDATIONS_SYNC' | 'IMAGE_VULNERABILITY_REMEDIATION' | 'DATABASE_INDEX_OPTIMIZER' | 'COMPLIANCE_FIX' | 'DISCOVERY_AGENT' | 'PROBE_ADDER'}
     * @memberof ModelsAPIApiModelsAPIGetModelsByRunbookType
     */
    readonly type: ModelsAPIGetModelsByRunbookTypeTypeEnum
}

/**
 * ModelsAPIApi - object-oriented interface
 * @export
 * @class ModelsAPIApi
 * @extends {BaseAPI}
 */
export class ModelsAPIApi extends BaseAPI {
    /**
     * Gets models used by all runbook types.
     * @summary Get models used by all runbook types.
     * @param {ModelsAPIApiModelsAPIGetModelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsAPIApi
     */
    public modelsAPIGetModels(requestParameters: ModelsAPIApiModelsAPIGetModelsRequest, options?: RawAxiosRequestConfig) {
        return ModelsAPIApiFp(this.configuration).modelsAPIGetModels(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the mapping of LLM providers to models used per runbook type
     * @summary Get the mapping between provider and models used per runbook type.
     * @param {ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsAPIApi
     */
    public modelsAPIGetModelsByRunbookType(requestParameters: ModelsAPIApiModelsAPIGetModelsByRunbookTypeRequest, options?: RawAxiosRequestConfig) {
        return ModelsAPIApiFp(this.configuration).modelsAPIGetModelsByRunbookType(requestParameters.organizationId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ModelsAPIGetModelsByRunbookTypeTypeEnum = {
    RUNBOOK_TYPE_UNSPECIFIED: 'RUNBOOK_TYPE_UNSPECIFIED',
    WOOP_RECOMMENDATIONS_SYNC: 'WOOP_RECOMMENDATIONS_SYNC',
    IMAGE_VULNERABILITY_REMEDIATION: 'IMAGE_VULNERABILITY_REMEDIATION',
    DATABASE_INDEX_OPTIMIZER: 'DATABASE_INDEX_OPTIMIZER',
    COMPLIANCE_FIX: 'COMPLIANCE_FIX',
    DISCOVERY_AGENT: 'DISCOVERY_AGENT',
    PROBE_ADDER: 'PROBE_ADDER'
} as const;
export type ModelsAPIGetModelsByRunbookTypeTypeEnum = typeof ModelsAPIGetModelsByRunbookTypeTypeEnum[keyof typeof ModelsAPIGetModelsByRunbookTypeTypeEnum];
